module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"liked":"Liked.","removed":"Rmoved.","error_occurred":"An error has occured.","are_you_sure_to_delete_this":"Are you sure to delete this?","deleted":"Deleted."}}')
  delete Component.options._Ctor
}
